import * as Global from "../common/global";
import { LoginControl } from "../common/login";
import { IController } from "../interfaces/controller";

// a login page
// this page is typically used on sites that use external authentication, to provide
// a way to login without the external authentication.
export class LoginController implements IController {
    // references to DOM elements
    private loginControl: LoginControl;
    constructor() {
        this.loginControl = new LoginControl();
    }

    public render(container: JQuery): JQuery.Promise<any, any, any> {
        const deferred: JQuery.Deferred<any, any, any> = $.Deferred();

        this.loginControl.render(container.find("div[data-id='loginControl']"));

        deferred.resolve();
        return deferred.promise();
    }

    public load(params: any[]): JQueryPromise<any> {
        const deferred: JQuery.Deferred<any, any, any> = $.Deferred();

        const app = Global.app();
        if (app.isLoggedIn) {
            // This page should only be used if the user is not logged in
            app.pageManager().closeAllAndGotoDefaultPage();
        }

        deferred.resolve();
        return deferred.promise();
    }

    public haveFieldsChanged(): boolean {
        // no editable fields
        return false;
    }

    public appRouterID(params: any[]): string {
        return "Login";
    }

    public title(): string {
        return "Login";
    }

    public subTitle(): string {
        return "";
    }
    public AllowAnonymousAccess(): boolean {
        return true;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--7!./src/script/controllers/login.ts